import DadataClient from 'dadata-js';

// noinspection JSUnresolvedVariable
const DADATA_TOKEN = process.env.VUE_APP_DADATA_TOKEN;
export default new DadataClient(DADATA_TOKEN);
